@if (advertisedDeployables !== undefined && advertisedDeployables.length > 0) {
  <div class="wm-m-slotinfo-templates wm-m-slotinfo-align-middle">
    <div [pTooltip]="advertisedDeployables[0].displayName" tooltipPosition="left" class="wm-m-slotinfo-template-logo">
      <img [src]="advertisedDeployables[0].logo"/>
    </div>
  </div>
}
@if (advertisedDeployables !== undefined && this.slot.isPublicSlot()) {
  <div class="wm-m-slotinfo-templates wm-m-slotinfo-align-middle">
    <div [pTooltip]="'Public Mobile Device'" tooltipPosition="left" class="wm-m-slotinfo-template-logo">
      <img [src]="'assets/img/generic_mobile.svg'"/>
      @if (slot.isCustomSlot()) {
        <fa-icon icon="info-circle" class="custom-slot"></fa-icon>
      }
    </div>
  </div>
}
@if (advertisedDeployables !== undefined && slot.isVCloudSlot() && slot.isWindowsSlot()) {
  <div class="wm-m-slotinfo-templates wm-m-slotinfo-align-middle">
    <div [pTooltip]="'Windows Virtual Machine'" tooltipPosition="left" class="wm-m-slotinfo-template-logo">
      <img [src]="'assets/img/generic_windows.svg'"/>
      @if (slot.isCustomSlot()) {
        <fa-icon icon="info-circle" class="custom-slot"></fa-icon>
      }
    </div>
  </div>
}
@if (advertisedDeployables !== undefined && slot.isVCloudSlot() && slot.isMacOSSlot()) {
  <div class="wm-m-slotinfo-templates wm-m-slotinfo-align-middle">
    <div [pTooltip]="'macOS Virtual Machine'" tooltipPosition="left" class="wm-m-slotinfo-template-logo">
      <img [src]="'assets/img/generic_macos.svg'"/>
      @if (slot.isCustomSlot()) {
        <fa-icon icon="info-circle" class="custom-slot"></fa-icon>
      }
    </div>
  </div>
}
@if (advertisedDeployables !== undefined && slot.isVCloudSlot() && !slot.isMacOSSlot() && !slot.isWindowsSlot()) {
  <div class="wm-m-slotinfo-templates wm-m-slotinfo-align-middle">
    <div [pTooltip]="'Virtual Machine'" tooltipPosition="left" class="wm-m-slotinfo-template-logo">
      <img [src]="'assets/img/generic_desktop.svg'"/>
      @if (slot.isCustomSlot()) {
        <fa-icon icon="info-circle" class="custom-slot"></fa-icon>
      }
    </div>
  </div>
}
@if (advertisedDeployables !== undefined && advertisedDeployables.length === 0 && !slot.isVCloudSlot() && !slot.isPublicSlot()) {
  <div class="wm-m-slotinfo-templates wm-m-slotinfo-align-middle">
    <div [pTooltip]="'No suitable devices'" tooltipPosition="left" class="wm-m-slotinfo-template-logo">
      <img [src]="'assets/img/generic_slot.svg'"/>
      @if (slot.isCustomSlot()) {
        <fa-icon icon="info-circle" class="custom-slot"></fa-icon>
      }
    </div>
  </div>
}
@if (advertisedDeployables === undefined) {
  <div class="wm-m-slotinfo-templates wm-m-slotinfo-align-middle">
    <p-progressSpinner [style]="{'width': matchOverview ? '30px' : '20px', 'height': matchOverview ? '30px' : '20px'}" [strokeWidth]="2"></p-progressSpinner>
  </div>
}
